import { g as getLocale, t as trackMessageCall } from "./runtime.js";
const en_verification_headline = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Enter verification key`;
  }
);
const de_verification_headline = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Verifizierung eingeben`;
  }
);
const sp_verification_headline = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Introduce la verificación`;
  }
);
const verification_headline = /* @__NO_SIDE_EFFECTS__ */ (inputs = {}, options = {}) => {
  const locale = options.locale ?? getLocale();
  trackMessageCall("verification_headline", locale);
  if (locale === "en") return en_verification_headline();
  if (locale === "de") return de_verification_headline();
  return sp_verification_headline();
};
const en_verification_subline = (
  /** @type {(inputs: { keyLength: NonNullable<unknown> }) => string} */
  (i) => {
    return `Please enter the ${i.keyLength} digit key we sent to your e-mail.`;
  }
);
const de_verification_subline = (
  /** @type {(inputs: { keyLength: NonNullable<unknown> }) => string} */
  (i) => {
    return `Bitte gebe die ${i.keyLength}-stelligen Verifizierung ein, die wir an Deine E-Mail gesendet haben.`;
  }
);
const sp_verification_subline = (
  /** @type {(inputs: { keyLength: NonNullable<unknown> }) => string} */
  (i) => {
    return `Por favor, introduce el código de verificación de ${i.keyLength} dígitos que hemos enviado a tu correo electrónico.`;
  }
);
const verification_subline = /* @__NO_SIDE_EFFECTS__ */ (inputs, options = {}) => {
  const locale = options.locale ?? getLocale();
  trackMessageCall("verification_subline", locale);
  if (locale === "en") return en_verification_subline(inputs);
  if (locale === "de") return de_verification_subline(inputs);
  return sp_verification_subline(inputs);
};
const en_send_again = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `send again`;
  }
);
const de_send_again = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Erneut senden`;
  }
);
const sp_send_again = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Enviar de nuevo`;
  }
);
const send_again = /* @__NO_SIDE_EFFECTS__ */ (inputs = {}, options = {}) => {
  const locale = options.locale ?? getLocale();
  trackMessageCall("send_again", locale);
  if (locale === "en") return en_send_again();
  if (locale === "de") return de_send_again();
  return sp_send_again();
};
const en_sending = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `sending`;
  }
);
const de_sending = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Sendet`;
  }
);
const sp_sending = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Enviando`;
  }
);
const sending = /* @__NO_SIDE_EFFECTS__ */ (inputs = {}, options = {}) => {
  const locale = options.locale ?? getLocale();
  trackMessageCall("sending", locale);
  if (locale === "en") return en_sending();
  if (locale === "de") return de_sending();
  return sp_sending();
};
const en_send_failed = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `send failed`;
  }
);
const de_send_failed = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Senden fehlgeschlagen`;
  }
);
const sp_send_failed = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Envío fallido`;
  }
);
const send_failed = /* @__NO_SIDE_EFFECTS__ */ (inputs = {}, options = {}) => {
  const locale = options.locale ?? getLocale();
  trackMessageCall("send_failed", locale);
  if (locale === "en") return en_send_failed();
  if (locale === "de") return de_send_failed();
  return sp_send_failed();
};
const en_verify = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `verify`;
  }
);
const de_verify = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Verifizieren`;
  }
);
const sp_verify = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Verificar`;
  }
);
const verify = /* @__NO_SIDE_EFFECTS__ */ (inputs = {}, options = {}) => {
  const locale = options.locale ?? getLocale();
  trackMessageCall("verify", locale);
  if (locale === "en") return en_verify();
  if (locale === "de") return de_verify();
  return sp_verify();
};
export {
  send_failed as a,
  sending as b,
  verification_subline as c,
  verify as d,
  send_again as s,
  verification_headline as v
};
